(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const faqSections = document.querySelectorAll('.faq-section');
    if (!faqSections.length) return;

    let faqData = null;
    const schemaScripts = document.querySelectorAll('script[type="application/ld+json"]');

    for (const script of schemaScripts) {
      let data;
      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        continue;
      }
      const candidates = Array.isArray(data) ? data : [data];
      const match = candidates.find(
        (entry) => entry && entry['@type'] === 'FAQPage' && Array.isArray(entry.mainEntity)
      );
      if (match) {
        faqData = match;
        break;
      }
    }

    if (!faqData) return;

    faqSections.forEach((section) => {
      const list = section.querySelector('.faq-section__list');
      if (!list || list.children.length > 0) return;

      const fragment = document.createDocumentFragment();

      faqData.mainEntity.forEach((item) => {
        const question = item && item.name;
        const answer = item && item.acceptedAnswer && item.acceptedAnswer.text;
        if (!question || !answer) return;

        const details = document.createElement('details');
        details.className = 'faq-section__item';

        const summary = document.createElement('summary');
        const questionSpan = document.createElement('span');
        questionSpan.textContent = question;
        const iconWrapper = document.createElement('span');
        iconWrapper.className = 'faq-section__icon-wrapper';
        const icon = document.createElement('span');
        icon.className = 'faq-section__icon';
        iconWrapper.appendChild(icon);
        summary.append(questionSpan, iconWrapper);

        const content = document.createElement('div');
        content.className = 'faq-section__content rte';
        const answerParagraph = document.createElement('p');
        answerParagraph.textContent = answer;
        content.appendChild(answerParagraph);

        details.append(summary, content);
        fragment.appendChild(details);
      });

      if (fragment.children.length) {
        list.appendChild(fragment);
      } else {
        section.hidden = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
